import { FC, useMemo } from 'react';
import MoreMenu from '@/components/more-menu';
import { TelemetryModel } from '@/lib/models/telemetry/telemetry.model';
import { AwsS3TelemetryModel } from '@/lib/models/telemetry/aws-s3-telemetry.model';
import { TelemetrySettings } from '@/lib/services/telemetry.service';
import CopyMenuItem from '@/components/more-menu/copy-menu-item';
import { UpdateMenuItemProps } from '@/components/more-menu/helpers';
import UpdateMenuItems from '@/components/more-menu/update-menu-items';

interface Props extends UpdateMenuItemProps {
  telemetry: TelemetryModel | null;
  settings?: TelemetrySettings;
}

const TelemetryMenu: FC<Props> = ({ telemetry, settings, showUpdateMenu, ...rest }) => {
  const telemetryType = telemetry?.type;
  const [userEventsUrl, auditEventsUrl] = useMemo(() => {
    if (!telemetry || !settings || telemetryType !== 's3') {
      return ['', ''];
    }
    const awsTelemetry = new AwsS3TelemetryModel(telemetry._props);
    return [
      awsTelemetry.getDestinationUrl(settings, 'user-event'),
      awsTelemetry.getDestinationUrl(settings, 'audit-event'),
    ];
  }, [telemetry, settings, telemetryType]);

  return (
    <MoreMenu menuId="telemetry-menu">
      {!!userEventsUrl && (
        <CopyMenuItem
          key="user-events"
          value={userEventsUrl}
          label="Copy User Events Destination URL"
          icon="link"
        />
      )}
      {!!auditEventsUrl && (
        <CopyMenuItem
          key="audit-events"
          value={auditEventsUrl}
          label="Copy Audit Events Destination URL"
          icon="link"
        />
      )}
      {showUpdateMenu && <UpdateMenuItems {...rest} />}
    </MoreMenu>
  );
};

export default TelemetryMenu;
